import { NavigateLink } from '@/components/navigate/NavigateLinks.tsx';
import { fleetPageBreadcrumbs } from '../../config/breadcrumbs';
import { NavigateFunction } from 'react-router-dom';

export const childrenAssignmentPageBreadcrumbs = (navigate: NavigateFunction): NavigateLink[] => [
  ...fleetPageBreadcrumbs(navigate),
  { label : 'Asignaciones', onClick: () => navigate('/fleet/assignment') },
];

export const childrenAssignmentTemplatesPageBreadcrumbs = (navigate: NavigateFunction): NavigateLink[] => [
  ...childrenAssignmentPageBreadcrumbs(navigate),
  { label: 'Plantillas', onClick: () => navigate('/fleet/assignment/plantillas') },
];
